import styled from 'styled-components';
import { LikeDislikeStyledProps } from '@catalogo/ui-americanas-desktop-product-review/src/types';

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: 7px;
  gap: 4px;
`;

const ContainerFeedback = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.grey.dark};
  font-size: 16px;
  border: none;
`;

const Like = styled.div<LikeDislikeStyledProps>`
  width: 17px;
  stroke: ${({ theme, userFeedback }) => (userFeedback ? theme.buttonLikeColor : theme.grey.dark)};
`;

const Unlike = styled(Like)`
  transform: rotate(180deg);
  stroke: ${({ theme, userFeedback }) => (userFeedback ? theme.buttonDislikeColor : theme.grey.dark)};
`;

const ActionRecommendation = styled.button`
  display: flex;
  background: transparent;
  border: 0;
  align-items: center;
  outline: none;
  cursor: pointer;
  padding: 0px;
`;

const LabelRecommendation = styled.span`
  color: ${({ theme }) => theme.grey.dark};
  margin-left: 5px;
  font-size: 12px;
`;

const RecommendationText = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 123.5%;
  display: flex;
  color: #666666;
`;

export { ActionRecommendation, ContainerFeedback, Flex, LabelRecommendation, Like, RecommendationText, Unlike };
